import { Customer, accountGroupKeyOf } from './customerTypes';

export interface CustomerAccountGroup {
  key: string;
  name: string;
  avatarCode: string | null;
  isGroupingNode: boolean;
  marketCount: number;
  customers: Customer[];
}

const bucketRank = (customer: Customer): number => {
  switch (customer.hierarchy.bucket) {
    case 'group':
      return 0;
    case 'independent':
      return 1;
    default:
      return 2;
  }
};

export const buildAccountGroups = (
  customers: Customer[]
): CustomerAccountGroup[] => {
  const order: string[] = [];
  const byKey = new Map<string, Customer[]>();

  customers.forEach((customer) => {
    const key = accountGroupKeyOf(customer);
    const existing = byKey.get(key);
    if (existing) {
      existing.push(customer);
      return;
    }
    order.push(key);
    byKey.set(key, [customer]);
  });

  return order
    .map((key) => {
      const groupCustomers = byKey.get(key) ?? [];
      const first = groupCustomers[0];
      const isGroupingNode = first?.hierarchy.bucket === 'group';
      const marketCount = new Set(groupCustomers.map((c) => c.market)).size;
      return {
        key,
        name: key,
        avatarCode: first?.hierarchy.groupAvatarCode ?? null,
        isGroupingNode,
        marketCount,
        customers: groupCustomers,
      };
    })
    .sort((a, b) => {
      const rankA = bucketRank(a.customers[0]);
      const rankB = bucketRank(b.customers[0]);
      if (rankA !== rankB) return rankA - rankB;
      return 0;
    });
};
